"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaqSubtopicQuestionFromJSON = FaqSubtopicQuestionFromJSON;
exports.FaqSubtopicQuestionFromJSONTyped = FaqSubtopicQuestionFromJSONTyped;
exports.FaqSubtopicQuestionToJSON = FaqSubtopicQuestionToJSON;
exports.FaqSubtopicQuestionToJSONTyped = FaqSubtopicQuestionToJSONTyped;
const _1 = require("./");
function FaqSubtopicQuestionFromJSON(json) {
    return FaqSubtopicQuestionFromJSONTyped(json, false);
}
function FaqSubtopicQuestionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'question': json['question'],
        'tag': json['tag'],
        'answer': (0, _1.FaqSubtopicQuestionAnswerFromJSON)(json['answer']),
    };
}
function FaqSubtopicQuestionToJSON(value) {
    return FaqSubtopicQuestionToJSONTyped(value, false);
}
function FaqSubtopicQuestionToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'question': value.question,
        'tag': value.tag,
        'answer': (0, _1.FaqSubtopicQuestionAnswerToJSON)(value.answer),
    };
}
